// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__cSlGc","expandIcon":"AccordionButton_expandIcon__R9aCN","expanded":"AccordionButton_expanded__53abY"};